import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiEyeFill, RiEyeOffFill } from "react-icons/ri";
import LogoImage from "../../../assets/logo/logo-02.png";
import MonitoredEnvironment from "../../../components/monitoredEnvironment/MonitoredEnvironment";
import { fetchInitialRegister } from "../../../integration/empresas/cadastro/fetchInitialRegister";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [loadingmaster, setLoadingmaster] = useState(false);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [senhaConfirm, setSenhaConfirm] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null); // Valor do CAPTCHA

  const chavecaptcha = "6LcMewIrAAAAANxl5tJHil_HrdXxUVLY7OLoLTTJ";

  function handleChangeEmail(event) {
    const emailValue = event.target.value;
    setEmail(emailValue);
  }

  function handleChangeSenha(event) {
    setSenha(event.target.value);
  }

  function handleChangeSenhaConfirm(event) {
    setSenhaConfirm(event.target.value);
  }

  function handleTogglePassword() {
    setShowPassword(!showPassword);
  }

  // Função para registrar o usuário
  async function funcRegister() {
    setLoadingmaster(true);

    // Expressão regular para validar o formato do e-mail
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    // Verifica se o e-mail é válido
    if (!emailRegex.test(email)) {
      setLoadingmaster(false);

      toast.warn("Formato de e-mail inválido", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se o e-mail for inválido
    }

    // Verifica se as senhas coincidem
    if (!senha) {
      setLoadingmaster(false);

      toast.warn("Insira uma senha", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se as senhas não coincidirem
    }

    // Verifica se as senhas coincidem
    if (!senhaConfirm) {
      setLoadingmaster(false);

      toast.warn("Confirme a senha", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se as senhas não coincidirem
    }

    // Verifica se as senhas coincidem
    if (senha !== senhaConfirm) {
      setLoadingmaster(false);

      toast.warn("As senhas não coincidem", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se as senhas não coincidirem
    }

    // Expressão regular para validar a senha
    const senhaRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\d\s]).{8,}$/;

    // Verifica se a senha atende aos critérios
    if (!senhaRegex.test(senha)) {
      setLoadingmaster(false);

      toast.warn("A senha não cumpre os requisitos de segurança necessários", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se a senha não atender aos critérios
    }

    try {
      const resp = await fetchInitialRegister(email, senha, senhaConfirm);
      if (resp) {
        toast.success(resp.message, {
          position: toast.POSITION.TOP_RIGHT
        });

        setLoadingmaster(false);

        // Redireciona para a página inicial após 5 segundos
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (error) {
      setLoadingmaster(false);

      toast.error(error.error, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  return (
    <>
      {/* Toast Notifications */}
      <ToastContainer />
      <MonitoredEnvironment />

      {!loadingmaster ? (
        <div className="flex items-center justify-center bg-gradient-to-b from-[#f2f2f2] to-[#fbf8f5] bg-cover bg-center">
          <div className="justify-center items-center self-center h-screen">
            <div className="flex items-center justify-center   bg-gradient-to-b from-[#f2f2f2] to-[#fbf8f5] bg-cover bg-center">
              <div className="justify-center items-center self-center   h-screen ">
                <div className=" "></div>
                <img
                  src={LogoImage}
                  alt="Logo"
                  className="h-28 w-auto mx-auto mb-5 mt-20"
                />
                <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                  Crie sua conta
                </h1>

                <div className="flex flex-col space-y-2 mt-4 mb-4">
                  <button
                    onClick={() => navigate("/")}
                    className="w-full text-center text-gray-600 py-2 rounded-2xl border border-gray-200  "
                  >
                    já tem uma conta? <b>Faça login aqui</b>
                  </button>
                </div>
                <div className="flex   items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-[#a48f74]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                    />
                  </svg>
                  <input
                    required
                    onChange={handleChangeEmail}
                    value={email}
                    type="email"
                    name="email"
                    id="email"
                    className="pl-2 bg-transparent  w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
                    placeholder="email"
                  />
                </div>
                <div className="w-96 border-2 none mb-5 rounded-lg border-[#ececec]">
                  {/* Requisitos da senha */}
                  <p className="text-xs text-gray-500 mt-3   text-center">
                    OBS: Sua senha deve conter pelo menos 1 letra maiúscula,
                  </p>

                  <p className="text-xs text-gray-500    mb-3  text-center">
                    1 minúscula, 1 número, 1 símbolo e ter pelo menos 8
                    caracteres.
                  </p>
                </div>
                <div className="flex items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-[#a48f74]"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <input
                    required
                    className="pl-2 bg-transparent  w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
                    placeholder="Sua senha"
                    onChange={handleChangeSenha}
                    value={senha}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                  />

                  {showPassword ? (
                    <RiEyeOffFill
                      className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                      onClick={handleTogglePassword}
                    />
                  ) : (
                    <RiEyeFill
                      className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                      onClick={handleTogglePassword}
                    />
                  )}
                </div>
                <div className="flex items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-[#a48f74]"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <input
                    required
                    className="pl-2 bg-transparent  w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
                    placeholder="Confirme sua senha"
                    onChange={handleChangeSenhaConfirm}
                    value={senhaConfirm}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                  />

                  {showPassword ? (
                    <RiEyeOffFill
                      className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                      onClick={handleTogglePassword}
                    />
                  ) : (
                    <RiEyeFill
                      className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                      onClick={handleTogglePassword}
                    />
                  )}
                </div>

                <button
                  type="button"
                  onClick={funcRegister}
                  className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                >
                  Criar uma conta
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center min-h-screen bg-white">
          <AiOutlineLoading3Quarters className="text-5xl text-[#a48f74] animate-spin" />
        </div>
      )}
    </>
  );
}
